import { render, staticRenderFns } from "./VisitorAgeVerification.vue?vue&type=template&id=5badb010&scoped=true"
import script from "./VisitorAgeVerification.vue?vue&type=script&lang=js"
export * from "./VisitorAgeVerification.vue?vue&type=script&lang=js"
import style0 from "./VisitorAgeVerification.vue?vue&type=style&index=0&id=5badb010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5badb010",
  null
  
)

export default component.exports